/* fix:发布后修改 index.html 中的 PUBLIC_URL 配置后资源加载路径不正确的问题 */
/* eslint-disable no-undef */
__webpack_public_path__ = (window.CONFIG.PUBLIC_URL || '') + '/';
